import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { Badge } from "../ui/badge";
import { Clock, BookOpen, Users, Target } from "lucide-react";

export function CurriculumSection() {
  const curriculum = [
    {
      session: "第1回",
      title: "AI‧DX化の必要性と⽣成AIの紹介⼊⾨",
      description: "⾃社現場の「⾮効率」 「専⾨化」などの課題を可視化（ 「⾯倒な作業」 「繰り返し仕事」などをリストアップします 。 ）",
      note: "※「面倒な作業」「繰り返し仕事」などをリストアップし次回以降に反映",
      structure: "⽂章⽣成、質問応答、業務活⽤できる⽣成AIを紹介",
      duration: "3時間",
      icon: Target
    },
    {
      session: "第2回",
      title: "⽣成AIを体験し、⽇常業務へ適⽤する",
      description: "議事録、社内⽂書、メール草案の⾃動化",
      note: "",
      structure: "座学2時間 + ワークショップ1時間",
      duration: "3時間",
      icon: BookOpen
    },
    {
      session: "第3回",
      title: "発展的な⽣成AIの業務利活⽤と社内活⽤計画の作成",
      description: "画像⽣成、キャッチコピー、報告書の⾃動⽣成体験業務での⽣成AI活⽤計画を検討し、発表とフィードバック",
      note: "現場業務内容によって応⽤⽅法を調整、最適化します",
      structure: "座学3時間 + ワークショップ1時間",
      duration: "4時間",
      icon: Users
    }
  ];

  return (
    <section className="py-20 px-4 bg-gray-50">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="mb-4 text-3xl md:text-4xl text-gray-900">
            モデル研修カリキュラム
          </h2>
          <div className="w-24 h-1 bg-black mx-auto mb-8"></div>
          <p className="text-lg text-gray-600 max-w-4xl mx-auto">
            基礎から実践まで、段階的にAI活用スキルを習得できる体系的なカリキュラム
          </p>
        </div>
        
        <div className="space-y-6 mb-12">
          {curriculum.map((item, index) => (
            <Card key={index} className="border-gray-200 shadow-sm bg-white">
              <CardHeader className="pb-4">
                <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                  <CardTitle className="flex items-start sm:items-center text-lg sm:text-xl text-gray-900">
                    <div className="w-8 h-8 sm:w-10 sm:h-10 bg-black text-white rounded-full flex items-center justify-center mr-3 sm:mr-4 text-xs sm:text-sm flex-shrink-0">
                      {index + 1}
                    </div>
                    <div className="flex-1">
                      <div className="text-sm sm:text-lg text-gray-600">{item.session}</div>
                      <div className="text-base sm:text-xl leading-tight">{item.title}</div>
                    </div>
                  </CardTitle>
                  <div className="flex items-center text-gray-600 self-start sm:self-center">
                    <Clock className="w-3 h-3 sm:w-4 sm:h-4 mr-1" />
                    <span className="text-xs sm:text-sm">{item.duration}</span>
                  </div>
                </div>
              </CardHeader>
              <CardContent>
                <p className="text-sm sm:text-base text-gray-700 mb-3 leading-relaxed">{item.description}</p>
                {item.note && (
                  <p className="text-xs sm:text-sm text-gray-600 mb-3 italic leading-relaxed">{item.note}</p>
                )}
                <div className="flex justify-start">
                  <Badge variant="outline" className="border-gray-300 text-gray-600 text-xs sm:text-sm px-2 py-1">
                    {item.structure}
                  </Badge>
                </div>
              </CardContent>
            </Card>
          ))}
        </div>
        
        <div className="bg-white p-8 rounded-xl border border-gray-200 text-center">
          <h3 className="text-2xl mb-4 text-gray-900">合計研修時間</h3>
          <div className="text-4xl mb-2 text-black">10時間</div>
          <p className="text-gray-600">助成金対象の研修時間を満たします</p>
        </div>
        
        <div className="mt-8 bg-gray-100 p-6 rounded-lg text-center">
          <p className="text-sm text-gray-700">
            ※研修内容は状況により変更になる可能性がございます。
          </p>
        </div>
      </div>
    </section>
  );
}
